module.exports = __webpack_public_path__ + "img/upload.0d6af8e2.png";